@use "../../../../theme/styles/typography.module";

.root {
  @include typography.typography-body-buttons;

  height: 32px;
  border-radius: 6px;
  background: var(--paletteNeutral1);
  color: var(--paletteBlue0);
  padding: var(--spacingMd) var(--spacingLg);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacingMd);
}
